import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ShopCatalog } from '#bv/components/ShopCatalog'
import { getMergedCatalogFn } from '#bv/lib/productCatalog'

const shopSearchSchema = z.object({
  q: z.string().optional(),
  /** Comma-separated category ids, e.g. `discord,streaming`. */
  category: z.string().optional(),
  /** Comma-separated price bucket ids: `under15`, `15-35`, `35-60`, `over60`. */
  price: z.string().optional(),
  sort: z.string().optional(),
})

export const Route = createFileRoute('/shop')({
  validateSearch: shopSearchSchema,
  staleTime: 0,
  loader: async () => ({
    catalog: await getMergedCatalogFn(),
  }),
  component: ShopPage,
})

function ShopPage() {
  const search = Route.useSearch()
  const { catalog } = Route.useLoaderData()
  return <ShopCatalog variant="shop" initial={search} catalog={catalog} />
}
